import React from 'react';

import ImgProfilePic from '~images/global/travis-hoki.jpg';

import './LinkedInLink.scss';

export const LinkedInLink = () => (
	<>
		<p className="preference-text">
			I prefer being contacted by email,
			<br />
			but also connect with me on LinkedIn.
		</p>

		<a
			className="linked-link"
			href="https://www.linkedin.com/in/travishoki"
			rel="noreferrer"
			target="_blank"
			title="Travis's Linked In"
		>
			<img
				className="linkedin-profile-image"
				height="50"
				src={ImgProfilePic}
				width="50"
			/>
			<p>Connect with me on</p>
			<i className="fa fa-linkedin" />
		</a>
	</>
);
